module.exports = __webpack_public_path__ + "assets/img/face_contrast_scene2.20064886.png";